/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';
import { CredentialSchemaUpdate } from '../../../../types/CredentialSchemaUpdate';

export const SchemaUpdateRequest: core.serialization.Schema<
    serializers.SchemaUpdateRequest.Raw,
    Omit<Truvity.SchemaUpdateRequest, 'idempotencyKey' | 'ifMatch'>
> = core.serialization.object({
    data: CredentialSchemaUpdate,
});

export declare namespace SchemaUpdateRequest {
    export interface Raw {
        data: CredentialSchemaUpdate.Raw;
    }
}
